import "./professionalBio.css";

const NicoleProfessionalJourney = (
  <div className="professional-journey">
    <p>
      Licensed Associate Professional Counselor
      <br />
      <br />
      Master of Education in Counselor Education, Clinical Mental Health:
      <br />
      <strong>Augusta University</strong>
      <br />
      <br />
      Bachelors of Science in Psychology: <br />
      <strong>Augusta University</strong>
      <br />
      <br />
    </p>
  </div>
);

export default NicoleProfessionalJourney;
